import React, {Component} from "react"
import styled from "styled-components"

import authentication from "@irati/auth"
import {TextArea} from "@irati/ui/src/FormItem"
import id from "@irati/utils/id"
import ReactIntl, {InjectIntl, injectIntl} from "@irati/utils/lang"
import {getTrimmed} from "@irati/utils/string"
import Validation from "@irati/utils/validation"

const StyleTextArea = styled(TextArea)`
  text-align: left;
  resize: none;
`

export const schema = (intl: ReactIntl.InjectedIntl, required: boolean, maxLength?: number) =>
  maxLength
    ? Validation.string(required ? intl.formatMessage({id: "platform.defaultValidation.required"}) : undefined).max(
      maxLength,
      intl.formatMessage({id: "platform.defaultValidation.maxLength"}, {count: intl.formatNumber(maxLength)})
    )
    : Validation.string(required ? intl.formatMessage({id: "platform.defaultValidation.required"}) : undefined)

const PROPERTY = "desc"

interface Props extends InjectIntl {
  label?: string,
  placeholder?: string,
  required?: boolean,
  maxLength?: number,
  id?: string,
  companyValue: {desc: string},
  onChange: (property: string, value: string) => void
}

class CompanyValuesDescription extends Component<Props> {
  static defaultProps: Omit<Props, "intl" | "formatMessage" | "onChange" | "companyValue"> = {
    id: "company-values",
    required: true
  }

  render() {
    const {companyValue, label, intl, onChange, placeholder, required, maxLength} = this.props
    const tenant = authentication.userTenant()
    return (
      <StyleTextArea
        id={id(PROPERTY, this.props)}
        label={label || intl.formatMessage({id: "admin.companyValues.fields.description.label"})}
        name={PROPERTY}
        maxLength={maxLength}
        onBlur={(_: React.FormEvent<HTMLTextAreaElement>, value: string) => onChange(PROPERTY, getTrimmed(value))}
        onChange={(value: string) => onChange(PROPERTY, value)}
        placeholder={
          placeholder || intl.formatMessage({id: "admin.companyValues.fields.description.placeholder"}, {tenantName: tenant.public_name})
        }
        rows={6}
        validation={schema(intl, required!, maxLength)}
        value={companyValue[PROPERTY]} />
    )
  }
}

export default injectIntl(CompanyValuesDescription)
